export default "__VITE_ASSET__CjTIKBWE__"